import real_estate from './real_estate.svg';
import food_and_beverage from './food_and_beverage.svg';
import beauty_and_cosmetics from './beauty_and_cosmetics.svg';
import fashion_and_apparel from './fashion_and_apparel.svg';
import medical_or_pharmaceutical from './medical_or_pharmaceutical.svg';
import construction from './construction.svg';
import gaming from './gaming.svg';
import sports_and_fitness from './sports_and_fitness.svg';

export default {
    real_estate,
    food_and_beverage,
    beauty_and_cosmetics,
    fashion_and_apparel,
    medical_or_pharmaceutical,
    construction,
    gaming,
    sports_and_fitness,
};
